import type { ReactNode } from 'react';

import { ChartBar, ChartBarStacked, ChartPie, Table } from '@mint-lib/icons';
import { Chip } from '@mint-lib/tw-components';

import { formatLabel } from '../../../../helpers/charts.js';
import type { ContentBlockSubtype } from '../../types.js';

const iconConfig: Record<ContentBlockSubtype, ReactNode> = {
  table: <Table />,
  graph: <ChartBar />,
  barchart: <ChartBar />,
  lineplot: <ChartBarStacked />,
  piechart: <ChartPie />,
  scatterplot: <ChartBar />,
};

const RelatedChip = ({
  text,
  subtype,
  onClick,
}: {
  text: string;
  subtype: ContentBlockSubtype;
  onClick: () => void;
}) => {
  return (
    <Chip
      variant={'outline'}
      color="tertiary"
      className="cursor-pointer hover:bg-transparent"
      onClick={onClick}
    >
      {iconConfig[subtype]}
      {formatLabel(text)}
    </Chip>
  );
};

export { RelatedChip };
